import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { IoMdCloudUpload } from "react-icons/io";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import {
  deleteData,
  editData,
  fetchDataFromApi,
  uploadImage,
} from "../../utils/api";

import { MyContext } from "../../App";

import NoUserImg from "../../assets/images/no-user.jpg";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "react-toastify";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const MyAccount = () => {
  const [value, setValue] = React.useState(0);

  const history = useNavigate();

  const context = useContext(MyContext);

  const [isLoading, setIsLoading] = useState(false);
  const [uploading, setUploading] = useState(false);

  const [preview, setPreview] = useState("");

  const [formFields, setFormFields] = useState({
    name: "",
    email: "",
    phone: "",
    images: [],
    isAdmin: false,
    password: "",
  });

  const [fields, setFields] = useState({
    oldPassword: "",
    password: "",
    confirmPassword: "",
  });

  const { setEnableFilterTab, setAlertBox } = context;

  useEffect(() => {
    setEnableFilterTab(false);
  }, [setEnableFilterTab]);

  useEffect(() => {
    window.scrollTo(0, 0);
    const token = localStorage.getItem("token");

    if (!token) {
      history("/signIn");
      return;
    }

    fetchDataFromApi(`/api/user/me`)
      .then((res) => {
        if (res) {
          setFormFields({
            name: res.name || "",
            email: res.email || "",
            phone: res.phone || "",
          });
          if (res.image) {
            setPreview(res.image);
          }
          localStorage.setItem("user", JSON.stringify(res));
        } else {
          setAlertBox({
            open: true,
            error: true,
            msg: "Could not fetch user data.",
          });
        }
      })
      .catch((error) => {
        console.error("Failed to fetch user data:", error);
        setAlertBox({
          open: true,
          error: true,
          msg: "An error occurred while fetching your data.",
        });
      });
  }, [history, setAlertBox, setEnableFilterTab]);

  const changeInput = (e) => {
    if (e.target.name === "phone") {
      let val = e.target.value;
      if (!val.startsWith("+91")) {
        val = "+91" + val.replace(/^\+?91?/, "");
      }
      val = "+91" + val.slice(3).replace(/[^0-9]/g, "");
      setFormFields({
        ...formFields,
        phone: val,
      });
    } else {
      setFormFields({
        ...formFields,
        [e.target.name]: e.target.value,
      });
    }
  };

  const changeInput2 = (e) => {
    setFields(() => ({
      ...fields,
      [e.target.name]: e.target.value,
    }));
  };

  const onChangeFile = async (e) => {
    const file = e.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/png" ||
        file.type === "image/webp")
    ) {
      setUploading(true);
      const formdata = new FormData();
      formdata.append("image", file);

      uploadImage("/api/user/upload-image", formdata).then((res) => {
        if (!res.error && res.imageUrl) {
          setPreview(res.imageUrl);
          setAlertBox({
            open: true,
            error: false,
            msg: "Image Uploaded!",
          });

          let user = JSON.parse(localStorage.getItem("user")) || {};
          user.image = res.imageUrl;
          user.images = [res.imageUrl];

          user.name = user.name || formFields.name;
          user.email = user.email || formFields.email;
          user.userId = user.userId || user._id;

          localStorage.setItem("user", JSON.stringify(user));
          if (context && typeof context.setUser === "function") {
            context.setUser(user);
          }
        } else {
          setAlertBox({
            open: true,
            error: true,
            msg: res.msg,
          });
        }
        setUploading(false);
      });
    } else {
      setAlertBox({
        open: true,
        error: true,
        msg: "Please select a valid JPG or PNG image file.",
      });
    }
  };

  const edituser = (e) => {
    e.preventDefault();

    if (formFields.name !== "" && formFields.phone.length > 3) {
      setIsLoading(true);
      editData(`/api/user/edit-profile`, formFields)
        .then((res) => {
          setIsLoading(false);
          if (!res.error) {
            setAlertBox({
              open: true,
              error: false,
              msg: "User details updated!",
            });
            toast.success("User details updated!");
          } else {
            setAlertBox({
              open: true,
              error: true,
              msg: res.msg,
            });
            toast.error(res.msg || "Failed to update profile");
          }
        })
        .catch((err) => {
          setIsLoading(false);
          setAlertBox({
            open: true,
            error: true,
            msg:
              err?.response?.data?.error ||
              err.message ||
              "Failed to update profile",
          });
          toast.error(
            err?.response?.data?.error ||
              err.message ||
              "Failed to update profile"
          );
        });
    } else {
      setAlertBox({
        open: true,
        error: true,
        msg: "Please fill all the details and enter a valid phone number",
      });
      toast.error("Please fill all the details and enter a valid phone number");
      return false;
    }
  };

  const changePassword = (e) => {
    e.preventDefault();

    if (
      fields.oldPassword !== "" &&
      fields.password !== "" &&
      fields.confirmPassword !== ""
    ) {
      if (fields.password !== fields.confirmPassword) {
        setAlertBox({
          open: true,
          error: true,
          msg: "Password and confirm password not match",
        });
      } else {
        const user = JSON.parse(localStorage.getItem("user"));

        const data = {
          email: user?.email,
          currentPassword: fields.oldPassword,
          newPassword: fields.password,
        };

        editData(`/api/user/changePassword/${user._id}`, data).then((res) => {
          if (res.error) {
            setAlertBox({
              open: true,
              error: true,
              msg: res.msg,
            });
          } else {
            setAlertBox({
              open: true,
              error: false,
              msg: "Password changed successfully",
            });
            // Clear the password fields
            setFields({
              oldPassword: "",
              password: "",
              confirmPassword: "",
            });
          }
        });
      }
    } else {
      setAlertBox({
        open: true,
        error: true,
        msg: "Please fill all the details",
      });
      return false;
    }
  };

  // Delete account handler
  const handleDeleteAccount = async () => {
    if (
      !window.confirm(
        "Are you sure you want to delete your account? This action cannot be undone."
      )
    )
      return;
    setIsLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const userId = user?.userId || user?._id;
      if (!userId) throw new Error("User ID not found");
      const res = await deleteData(`/api/user`);
      if (res && res.success) {
        toast.success("Account deleted successfully.");
        localStorage.clear();
        context.setIsLogin(false);
        context.setUser(null);
        setTimeout(() => {
          history("/signIn");
        }, 1000);
      } else {
        toast.error(res?.message || res?.error || "Failed to delete account.");
      }
    } catch (err) {
      toast.error(err?.message || "Failed to delete account.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        {/* Title */}
        <title>My Account - SabbaFarm</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Manage your profile, orders, and account settings on SabbaFarm. View your purchase history, update personal information, and more."
        />

        {/* Robots meta tag to allow indexing */}
        <meta name="robots" content="index, follow" />

        {/* Open Graph Tags */}
        <meta property="og:title" content="My Account - SabbaFarm" />
        <meta
          property="og:description"
          content="Manage your profile, orders, and account settings on SabbaFarm. View your purchase history, update personal information and more."
        />
        <meta property="og:url" content="https://sabbafarm.com/my-account" />
        <meta property="og:type" content="website" />
      </Helmet>
      <section className="section myAccountPage">
        <div className="container">
          <h2 className="hd">My Account</h2>

          <Box sx={{ width: "100%" }} className="myAccBox card border-0">
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={0}
                aria-label="basic tabs example"
                // Only one tab now
              >
                <Tab label="Edit Profile" {...a11yProps(0)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={0} index={0}>
              <form onSubmit={edituser}>
                <div className="row">
                  <div className="col-md-4">
                    <div className="userImage  d-flex align-items-center justify-content-center">
                      {uploading === true ? (
                        <CircularProgress />
                      ) : (
                        <>
                          {preview ? (
                            <img src={preview} alt="Profile Preview" />
                          ) : (
                            <img src={NoUserImg} alt="No User" />
                          )}
                          <div className="overlay d-flex align-items-center justify-content-center">
                            <IoMdCloudUpload />
                            <input
                              type="file"
                              onChange={onChangeFile}
                              name="image"
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                  <div className="col-md-8">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <TextField
                            label="Name"
                            variant="outlined"
                            className="w-100"
                            name="name"
                            onChange={changeInput}
                            value={formFields.name}
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <TextField
                            label="Email"
                            disabled
                            variant="outlined"
                            className="w-100"
                            name="email"
                            onChange={changeInput}
                            value={formFields.email}
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <TextField
                            label="Phone"
                            variant="outlined"
                            className="w-100"
                            name="phone"
                            onChange={changeInput}
                            value={formFields.phone}
                            inputProps={{ maxLength: 13 }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="form-group d-flex" style={{ gap: "15px" }}>
                      <Button
                        type="submit"
                        variant="contained"
                        className="btn-lg btn-big"
                        sx={{
                          backgroundColor: "#8bc34a",
                          "&:hover": {
                            backgroundColor: "#7cb342",
                          },
                          width: "fit-content",
                          padding: "10px 20px",
                        }}
                      >
                        {isLoading === true ? (
                          <CircularProgress size={24} color="inherit" />
                        ) : (
                          "Save"
                        )}
                      </Button>
                      <Button
                        type="button"
                        variant="contained"
                        className="btn-lg btn-big"
                        sx={{
                          backgroundColor: "#f44336",
                          "&:hover": {
                            backgroundColor: "#d32f2f",
                          },
                          width: "fit-content",
                          padding: "10px 20px",
                        }}
                        onClick={handleDeleteAccount}
                        disabled={isLoading}
                      >
                        {isLoading === true ? (
                          <CircularProgress size={24} color="inherit" />
                        ) : (
                          "Delete Account"
                        )}
                      </Button>
                    </div>
                  </div>
                </div>
              </form>
            </CustomTabPanel>
          </Box>
        </div>
      </section>
    </>
  );
};

export default MyAccount;
